import axios from "axios";
import store from "redux/Store";
import { v4 as uuidv4 } from "uuid";
import { validateClearanceWizard, validateUniqueValue } from "../../util/validations/ClearanceWizardValidation";
import { pagingTotalRelation, userPrefType } from "../Types";
import { trimSearchQuery } from "../../util/CommonFunc";
import { getCtagOnAddTrack } from "_clearance/utils/utils";
var reducerModule = "/mlLic/forms/";
export const actionTypes = {
  LOADING: "LOADING" + reducerModule,
  LOAD: "LOAD" + reducerModule,
  ERROR: "ERROR" + reducerModule,
  CLEAR_ERRORS: "CLEAR_ERRORS" + reducerModule,
  FOCUS_ITEM: "FOCUS_ITEM" + reducerModule,
  SELECT_ITEMS: "SELECT_ITEMS" + reducerModule,
  QUERY: "QUERY" + reducerModule,
  EDIT_ITEM: "EDIT_ITEM" + reducerModule,
  POSTING: "POSTING" + reducerModule,
  POST_OK: "POSTOK" + reducerModule,
  POST_ERROR: "POST_ERROR" + reducerModule,
  RECENT_LOADING: "RECENT_LOADING" + reducerModule,
  RECENT_LOAD: "RECENT_LOAD" + reducerModule,
  RECENT_ERROR: "RECENT_LOAD" + reducerModule,
  RECENT_QUERY: "RECENT_QUERY" + reducerModule,
  REFRESH_ITEMS: "REFRESH_ITEMS" + reducerModule,
  LAST_REFRESH: "LAST_REFRESH" + reducerModule,
  IS_ALLOCATED_OPEN: "IS_ALLOCATED_OPEN" + reducerModule,
  LOAD_HISTORY: "LOAD_HISTORY" + reducerModule,
  REMOVE_HISTORY: "REMOVE_HISTORY" + reducerModule,
  VALIDATING: "VALIDATING" + reducerModule,
  VALIDATING_OK: "VALIDATING_OK" + reducerModule,
  VALIDATING_ERROR: "VALIDATING_ERROR" + reducerModule,
  CF_Share: "CF_Share" + reducerModule,
  CF_Share_OK: "CF_Share_OK" + reducerModule,
  RESET: "RESET" + reducerModule,
  COPY_TRACK_RESET: "COPY_TRACK_RESET" + reducerModule,
  COPY_SELECTED_TRACK_RESET: "COPY_SELECTED_TRACK_RESET" + reducerModule,
  TRIGGER_FETCH_EPISODES: "TRIGGER_FETCH_EPISODES" + reducerModule,
  COPY_TRACK_QUERY: "COPY_TRACK_QUERY" + reducerModule,
  COPY_TRACK_SELECT_ITEMS: "COPY_TRACK_SELECT_ITEMS" + reducerModule,
  LOADING_COPY_TRACKS: "LOADING_COPY_TRACKS" + reducerModule,
  LOAD_COPY_TRACKS: "LOAD_COPY_TRACKS" + reducerModule,
  COPY_SELECTED_TRACK_QUERY: "COPY_SELECTED_TRACK_QUERY" + reducerModule,
  COPY_SELECTED_TRACK_SELECT_ITEMS: "COPY_SELECTED_TRACK_SELECT_ITEMS" + reducerModule,
  LOADING_COPY_SELECTED_TRACKS: "LOADING_COPY_SELECTED_TRACKS" + reducerModule,
  LOAD_COPY_SELECTED_TRACKS: "LOAD_COPY_SELECTED_TRACKS" + reducerModule,
  COPY_TRACK_FOCUS_ITEM: "COPY_TRACK_FOCUS_ITEM" + reducerModule,
  COPY_SELECTED_TRACK_FOCUS_ITEM: "COPY_SELECTED_TRACK_FOCUS_ITEM" + reducerModule,
};

export const reset = () => (dispatch) => {
  dispatch({
    type: actionTypes.RESET,
    payload: null,
  });
};

export const resetCopyTracks = () => (dispatch) => {
  dispatch({
    type: actionTypes.COPY_TRACK_RESET,
    payload: null,
  });
};

export const resetCopySeletedTracks = () => (dispatch) => {
  dispatch({
    type: actionTypes.COPY_SELECTED_TRACK_RESET,
    payload: null,
  });
};

export const editItem = (item) => (dispatch) => {
  dispatch({
    type: actionTypes.EDIT_ITEM,
    payload: item,
  });
};

export const refreshItems = (items) => (dispatch) => {


 
  dispatch({
    type: actionTypes.REFRESH_ITEMS,
    payload: items,
  });
};

export const setLastRefresh = (items) => (dispatch) => {
  dispatch({
    type: actionTypes.LAST_REFRESH,
    payload: items,
  });
};

export const setIsAllocatedSectionOpen = (state) => (dispatch) => {
  dispatch({
    type: actionTypes.IS_ALLOCATED_OPEN,
    payload: state,
  });
};

export const removeHistory = (cfId) => (dispatch) => {
  dispatch({
    type: actionTypes.REMOVE_HISTORY,
    payload: cfId,
  });
};

export const createConvertedTrack = (newTrack, done = null) => (dispatch) => {
  const {
    user: {
      credentials: { orgID },
    },
  } = store.getState();
  const tId = uuidv4();
  axios
  .post(`${orgID}/mllic/forms/createConvertedTrack`, newTrack, {
    headers: { tid: tId, orgid: orgID },
  })
  .then((res) => {
    if (done) done(res.data, null);
  })
  .catch((err) => {
    console.log(err)
    if (done) done(null, err);
  });
};

export const showAutoMessage = (message) => (dispatch) => {
  dispatch({
    type: actionTypes.CF_Share,
    payload: message,
  });
  setTimeout(() => {
    dispatch({
      type: actionTypes.CF_Share_OK,
    });
  }, 3000);
};

export const getFormHistory = (cfId, hybridId = null, done = null) => (dispatch) => {
  //   if (done) done({}, null);
  // }
  const {
    user: {
      credentials: { orgID },
    },
  } = store.getState();
  const tId = uuidv4();

  // dispatch({
  //   type: actionTypes.POSTING,
  //   payload: message,
  // });

  axios
    .post(`${orgID}/mllic/forms/searchHistory`, { cfId: cfId, hybridId: hybridId }, {
      headers: { tid: tId, orgid: orgID },
    })
    .then((res) => {
      //if (res.data.tid === tId) {
      dispatch({
        type: actionTypes.LOAD_HISTORY,
        payload: {
          cfId:cfId,
          history:res.data.sort((a, b) => {
            const dateA = new Date(a.dateCreated);
            const dateB = new Date(b.dateCreated);
            return dateB - dateA;
          })
        }
      });

      if (done) done(res.data, null);
      //}
    })
    .catch((err) => {
      // dispatch({
      //   type: actionTypes.POST_ERROR,
      //   // payload: { e: err },
      //   payload: err.response?.data || { e: (err.message ? err.message : "Error in creating or updating. please retry") },
      // });

      // if (done) done(null, err.response?.data?.name == 'Duplicate Name'?err.response?.data?.name:err.message || "error");
    });
};

export const postItem = (action, message, items, done = null) => async (dispatch) => {
 
  dispatch({
    type: actionTypes.POSTING,
    payload: message,
  });

  if (action === "saveform" && items.cf) {
    let errors = await validateClearanceWizard(items.cf);
    if (errors) {
      dispatch({
        type: actionTypes.POST_ERROR,
        payload: errors
      });
      if (done) done(null, errors);
      return;
    }
    if(items.cf.fieldsToValidate){
      delete items.cf.fieldsToValidate;
    }
  }

  const {
    user: {
      credentials: { orgID },
    },
    orgRuntime
  } = store.getState();
  const tId = uuidv4();


  axios
    .post(`${orgID}/mllic/forms/${action}`, items, {
      headers: { tid: tId, orgid: orgID },
    })
    .then((res) => {
      //if (res.data.tid === tId) {
      dispatch({
        type: actionTypes.POST_OK,
      });

      if (action === "addtracks"){
        getCtagOnAddTrack(res.data?.tracks, items.confirmed, orgRuntime, res.data?.trackSequence);
        dispatch({
          type: actionTypes.TRIGGER_FETCH_EPISODES,
          payload: null,
        });
      }
      if (done) done(res.data, null);
      //}
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.POST_ERROR,
        // payload: { e: err },
        payload: err.response?.data || { e: (err.message ? err.message : "Error in creating or updating. please retry") },
      });

      if (done) done(null, err.response?.data?.name === 'Duplicate Name'?err.response?.data?.name:err.message || "error");
    });
};

export const setQuery = (query, done = null) => (dispatch) => {
  dispatch({
    type: actionTypes.QUERY,
    payload: query,
  });

  if (done) done();
};
export const setCopyTrackQuery = (query, done = null) => (dispatch) => {
  dispatch({
    type: actionTypes.COPY_TRACK_QUERY,
    payload: query,
  });

  if (done) done();
};
export const setSelectedCopyTrackQuery = (query, done = null) => (dispatch) => {
  dispatch({
    type: actionTypes.COPY_SELECTED_TRACK_QUERY,
    payload: query,
  });

  if (done) done();
};

export const setRecentCFQuery = (query, done = null) => (dispatch) => {
  dispatch({
    type: actionTypes.RECENT_QUERY,
    payload: query,
  });

  if (done) done();
};

export const selectItems = (items) => (dispatch) => {
  dispatch({
    type: actionTypes.SELECT_ITEMS,
    payload: items,
  });
};
export const copyTrackSelectItems = (items) => (dispatch) => {
  dispatch({
    type: actionTypes.COPY_TRACK_SELECT_ITEMS,
    payload: items,
  });
};
export const selectedCopyTrackSelectItems = (items) => (dispatch) => {
  dispatch({
    type: actionTypes.COPY_SELECTED_TRACK_SELECT_ITEMS,
    payload: items,
  });
};

export const focusItem = (item) => (dispatch) => {
  dispatch({
    type: actionTypes.FOCUS_ITEM,
    payload: item,
  });
};
export const copyTrackFocusItem = (item) => (dispatch) => {
  dispatch({
    type: actionTypes.COPY_TRACK_FOCUS_ITEM,
    payload: item,
  });
};
export const selectedCopyTrackFocusItem = (item) => (dispatch) => {
  dispatch({
    type: actionTypes.COPY_SELECTED_TRACK_FOCUS_ITEM,
    payload: item,
  });
};
export const search = (query) => (dispatch) => {
  const {
    user: {
      credentials: { orgID },
    },
  } = store.getState();

  const tId = uuidv4();
  dispatch({
    type: actionTypes.LOADING,
  });

  axios
    .post(`${orgID}/mllic/forms/search`, trimSearchQuery(query), {
      headers: { tid: tId, orgid: orgID },
    })
    .then((res) => {
      if (res.data.tid === tId) {
        dispatch({
          type: actionTypes.LOAD,
          payload: res.data.results,
          total: res.data.total,
          totalRelation: res.data.totalRelation || pagingTotalRelation.EQUALS,
        });
      }
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.ERROR,
        payload: { e: err.message || "error" },
      });
    });
};

export const searchCopyTracks = (query) => (dispatch) => {
  const {
    user: {
      credentials: { orgID },
    },
    mllicformcontent: {
      editing
    }
  } = store.getState();

  const tId = uuidv4();
  dispatch({
    type: actionTypes.LOADING_COPY_TRACKS,
  });

  axios
    .post(`${orgID}/mllic/forms/searchcopytracks`, {
      ...trimSearchQuery(query), 
      currentFormId: editing.id
    }, {
      headers: { tid: tId, orgid: orgID },
    })
    .then((res) => {
      if (res.data.tid === tId) {
        dispatch({
          type: actionTypes.LOAD_COPY_TRACKS,
          payload: res.data.results,
          total: res.data.total,
          totalRelation: res.data.totalRelation || pagingTotalRelation.EQUALS,
        });
      }
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.ERROR,
        payload: { e: err.message || "error" },
      });
    });
};

export const searchSelectedCopyTracks = (query) => (dispatch) => {
  const {
    user: {
      credentials: { orgID },
    },
    mllicformcontent: {
      editing
    }
  } = store.getState();

  const tId = uuidv4();
  dispatch({
    type: actionTypes.LOADING_COPY_SELECTED_TRACKS,
  });

  axios
    .post(`${orgID}/mllic/forms/searchselectedcopytracks`, {
      ...trimSearchQuery(query), 
    }, {
      headers: { tid: tId, orgid: orgID },
    })
    .then((res) => {
      if (res.data.tid === tId) {
        dispatch({
          type: actionTypes.LOAD_COPY_SELECTED_TRACKS,
          payload: res.data.results,
          total: res.data.total,
          totalRelation: res.data.totalRelation || pagingTotalRelation.EQUALS,
        });
      }
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.ERROR,
        payload: { e: err.message || "error" },
      });
    });
};

export const searchCFRecent = (query) => (dispatch) => {
  const {
    user: {
      credentials: { orgID },
    },
  } = store.getState();

  const tId = uuidv4();
  dispatch({
    type: actionTypes.RECENT_LOADING,
  });

  axios
    .post(`${orgID}/mllic/forms/searchRecent`, query, {
      headers: { tid: tId, orgid: orgID },
    })
    .then((res) => {
      if (res.data.tid === tId) {
        dispatch({
          type: actionTypes.RECENT_LOAD,
          payload: res.data.results,
        });
      }
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.RECENT_ERROR,
        payload: { e: err.message || "error" },
      });
    });
};

export const updateSearchUserPref = (pref, message, done = null) => (
  dispatch
) => {
  const {
    user: { id },
  } = store.getState();
  const tId = uuidv4();
  dispatch({
    type: actionTypes.POSTING,
    payload: message,
  });

  axios
    .post(
      `${id}/userpref/update`,
      { type: userPrefType.CLERANCEFORMSPREF, pref: pref },
      {
        headers: { tid: tId },
      }
    )
    .then((res) => {
      dispatch({
        type: actionTypes.POST_OK,
      });

      if (done) done(res.data, null);
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.POST_ERROR,
        payload: { e: err },
      });

      if (done) done(null, err);
    });
};

export const clearErrors = (param = "", done = null) => (dispatch) => {

  const {
    mllicform: { posting },
    clearanceRuntime: { runtime },
  } = store.getState();
  
  if(param && posting.errors){
    let headerq = runtime && runtime._config && runtime._config?.CF_HEADER_FIELD_LIST?.filter(f=> f.id === param) || [];

    if(posting.errors[param]){
      delete posting.errors[param];    
    }
    
    if(headerq.length > 0 && headerq[0].subQuestions && headerq[0].subQuestions.length > 0){
      headerq[0].subQuestions.forEach(e => {
        delete posting.errors[e.id];
      });
    }

    dispatch({
      type: actionTypes.CLEAR_ERRORS,
      payload: {...posting.errors},
    });
  } 
  else if(!param){
    dispatch({
      type: actionTypes.CLEAR_ERRORS,
      payload: {},
    });
  }

  if (done) done();
};

export const checkUniqueValue = (field, value, cfId, done = null) => async (dispatch) =>{

  dispatch({
    type: actionTypes.VALIDATING,
    payload: "Validating...",
  });

  let isUnique = await validateUniqueValue(field, value, cfId) ?? false;

  if(isUnique){
    clearErrors(field.id);
    dispatch({
      type: actionTypes.VALIDATING_OK,
    });

  }else{
    dispatch({
      type: actionTypes.VALIDATING_ERROR,
      payload: {[field.id]: `${field.label} already in use`},
    });
  }
}
